import React, { FC } from "react";
import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import InfoIcon from "../../../../../components/InfoIcon";

const useStyles = makeStyles(() => ({
  currencyContainer: {
    width: 226,
  },
  currencyLabel: {
    fontSize: 14,
    lineHeight: 1,
    color: "#a1a4ac",
  },
  currency: {
    marginTop: 14,
    fontSize: 16,
    color: "#bcbcbc",
  },
  currencyValue: {
    color: "#494949",
  },
}));

interface ShowCurrency {
  currency: string;
  infoText?: string;
}

const ShowCurrency: FC<ShowCurrency> = ({ currency, infoText = "" }) => {
  const classes = useStyles();

  return (
    <div className={classes.currencyContainer}>
      <div className={classes.currencyLabel}>
        Currency {infoText && <InfoIcon text={infoText} portalMode={false} />}
      </div>
      <p className={clsx(classes.currency, currency && classes.currencyValue)}>
        {currency ? currency : "N/A"}
      </p>
    </div>
  );
};

export default React.memo(ShowCurrency);
